export default __webpack_public_path__ + "static/media/linux-mint.2019303a.svg";